import * as React from "react";
const SvgModules24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M12 0H0v9h12V0ZM2 7V2h8v5H2Zm4 4H0v9h6v-9Zm-4 7v-5h2v5H2ZM14 0h6v9h-6V0Zm2 2v5h2V2h-2Zm4 18v-9H8v9h12Zm-10-2v-5h8v5h-8Z",
      clipRule: "evenodd"
    })
  );
export default SvgModules24Px;
